<template>
  <LogMessage :text="logContent" />
</template>

<script>
import { mapGetters } from 'vuex'
import LogMessage from './LogMessage.vue'

export default {
  components: { LogMessage },
  computed: {
    ...mapGetters({
      logContent: 'logs/currentLogContent',
    }),
  },
}
</script>
